import { render } from "./UpcomingEventsContentButtons.vue?vue&type=template&id=612d2520"
import script from "./UpcomingEventsContentButtons.vue?vue&type=script&lang=js"
export * from "./UpcomingEventsContentButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__